<template>
  <div class="content-our-photo">
    <div class="content-our-photo--title">
      <h2>Anexar audio</h2>
    </div>
    <div class="content-our-photo-body">
      <input type="file" ref="fileupload" name="picture" id="input--file" @change="previewFile($event)" accept=".mp3" :required="!audio"/>
      <label class="btn--new-photo" for="input--file">
        <img class="img-fluid" src="@/assets/img/icon-add.png" alt="icon plus" title="icon plus"/>
      </label>
      <div class="content-our-photo-body-image" v-if="audio">
        <button class="content-our-photo-body-image--bg bg--file"
          :style="{ background: `url(${require(`@/assets/img/${this.image}`)})` }"
          type="button">
        </button>
        <p class="bg--file-text">{{ audio.name }}</p>
        <button class="btn-remove-photo" type="button" @click="clearInputFile()">
          <img class="img-fluid" src="@/assets/img/icon-close.png" alt="icon remove" title="icon remove"/>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import mixinUploadAudio from '@/mixins/mixinUploadAudio';

export default {
  mixins: [mixinUploadAudio],
}
</script>

<style lang="scss" scoped>
.bg--file {
  background-size: 70px !important;
  &-text {
    width: 100%;
    position: absolute;
    font-size: 12px;
    font-family: 'Font Light';
    color: var(--black);
    text-align: center;
    word-break: break-word;
    margin-bottom: 0;
  }
}
</style>
